import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
import { IShipmentUnit } from "../../interfaces/order";

const OrderShipmentUnitsContent = ({
  shipmentUnits,
}: {
  shipmentUnits: IShipmentUnit[];
}) => {
  return (
    <Grid container flexDirection="column" spacing={0.5}>
      {shipmentUnits?.map(
        (
          { content, height, width, depth, weight }: IShipmentUnit,
          index: number,
        ) => {
          return (
            <Grid item xs={12} key={index}>
              <Paper
                elevation={0}
                className="p-10 bg-light"
                sx={{
                  borderColor: "divider",
                  borderRadius: 2,
                }}
              >
                <Box className="d-flex align-items-center m-b-20">
                  <Box
                    sx={{
                      width: 36,
                      height: 36,
                      borderRadius: 1.5,
                      bgcolor: "primary",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: 1.5,
                    }}
                  >
                    <Typography className="f-s-14" fontWeight={600}>
                      #{index + 1}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      variant="subtitle1"
                      fontWeight={700}
                      lineHeight={1.2}
                    >
                      Bulto Virtual Optimizado
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Dimensiones: {height} × {width} × {depth} cm | Peso total:{" "}
                      {weight}kg
                    </Typography>
                  </Box>
                </Box>

                <Divider className="m-b-20" />
                <Typography
                  variant="subtitle2"
                  fontWeight={600}
                  className="m-b-10"
                >
                  Contenido del paquete:
                </Typography>

                <Grid container spacing={3}>
                  {content.map(({ sku, quantity }, contentIndex) => {
                    const safeSku = sku || "-";
                    const safeQuantity = Number(quantity) || 0;

                    return (
                      <Grid
                        item
                        xs={12}
                        key={`${safeSku}-${index}-${contentIndex}`}
                      >
                        <Box
                          className="p-10"
                          sx={{
                            backgroundColor: "secondary.light",
                            borderRadius: "6px",
                            border: "1px solid #e9ecef",
                          }}
                        >
                          <Typography className="text-bold" variant="body2">
                            SKU: {safeSku}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            Cantidad: {safeQuantity} unidades
                          </Typography>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Paper>
            </Grid>
          );
        },
      )}
    </Grid>
  );
};

export default OrderShipmentUnitsContent;
